// import "/assets/css/login.css";
import FrontendLayout from "../../layouts/FrontendLayout";
import Helmet from "../../components/Helmet";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import api from "../../api/axiosInstance";

export default function HomePreview() {
  const [loading, setLoading] = useState(true);
  const [previewData, setPreviewData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPreviewData = async () => {
      try {
        setLoading(true);
        const res = await api.get("/fetchPreviewData");
        setPreviewData(res.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPreviewData();
  }, []);

  useEffect(() => {
    if (previewData.FINAL_SUBMIT === '1') {
      navigate("/completed");
    }
    if (previewData.FORM_STATUS === '0') {
      navigate("/personal");
    }
  });

  return (
    <>
      <Helmet title="Preview" />
      <FrontendLayout />
      <ToastContainer />

      {loading ? (
        <div className="full-page-loader">
          <ClipLoader size={60} />
        </div>
      ) : (
        <div className="main">
          <section className="container-fluid py-4" style={{ width: "95%" }}>
            <h4 className="text-center text-primary fw-bold mb-4">
              FINANCIAL SUPPORT SCHEME (FSS) 2026-27
            </h4>

            <div className="card shadow p-2 p-md-4 mb-4">
              <h5 className="text-center bg-primary text-white py-2 rounded mb-4">
                Personal Details
              </h5>
              <div
                className="table-responsive"
                style={{ WebkitOverflowScrolling: "touch" }}
              >
                <table className="table table-striped table-bordered ">
                  <tbody>
                    <tr>
                      <th>Student's Name</th>
                      <td>{previewData?.STUDENT_NAME || "N/A"}</td>
                      <th>SOL Roll Number</th>
                      <td>{previewData?.SOL_ROLL_NO || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Contact No.</th>
                      <td>{previewData?.MOBILE || "N/A"}</td>
                      <th>Programme</th>
                      <td>{previewData?.COURSE || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Admission Year</th>
                      <td>{previewData?.ADMISSION_YEAR || "N/A"}</td>
                      <th>Current semester</th>
                      <td>{previewData?.SEMESTER || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Aadhaar Number</th>
                      <td>{previewData?.STUDENT_ADHAR_NO || "N/A"}</td>
                      <th>PAN Number</th>
                      <td>{previewData?.STUDENT_PAN_NO || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Bank Holder Name</th>
                      <td>{previewData?.BANK_HOLDER_NAME || "N/A"}</td>
                      <th>Bank Account Number</th>
                      <td>{previewData?.STUDENT_BANK_ACC || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Bank IFSC</th>
                      <td>{previewData?.BANK_IFSC_CODE || "N/A"}</td>
                      <th>Bank Name</th>
                      <td>{previewData?.STUDENT_BANK_NAME || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Father's Name</th>
                      <td>{previewData?.FATHER_NAME || "N/A"}</td>
                      <th>Father's Occupation</th>
                      <td>{previewData?.FATHER_TYPE_OF_JOB || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Father's Annual Income</th>
                      <td>{previewData?.FATHER_ANNUAL_INCOME || "N/A"}</td>
                      <th>Father's PAN</th>
                      <td>{previewData?.FATHER_PAN_NO || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Father's ITR Value</th>
                      <td>{previewData?.FATHER_ITR || "N/A"}</td>
                      <th>Mother's Name</th>
                      <td>{previewData?.MOTHER_NAME || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Mother's Occupation</th>
                      <td>{previewData?.MOTHER_TYPE_OF_JOB || "N/A"}</td>
                      <th>Mother's Annual Income</th>
                      <td>{previewData?.MOTHER_ANNUAL_INCOME || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Mother's PAN</th>
                      <td>{previewData?.MOTHER_PAN_NO || "N/A"}</td>
                      <th>Mother's ITR Value</th>
                      <td>{previewData?.MOTHER_ITR || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Total Annual Family Income</th>
                      <td>{previewData?.TOTAL_FAMILY_INCOME || "N/A"}</td>
                      <th>Total Annual Family Income Lies Between</th>
                      <td>{previewData?.INCOME_LIES_BETWEEN || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>No. of Dependent Family Members</th>
                      <td>{previewData?.DEPENDENT_MEMBER || "N/A"}</td>
                      <th>Income Certificate No</th>
                      <td>{previewData?.INCOME_CERTIFICATE_NO || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Income Certificate Issued By</th>
                      <td>{previewData?.INCOME_ISSUED_BY || "N/A"}</td>
                      <th>Income Certificate Issued Date</th>
                      <td>
                        {new Date(
                          previewData?.INCOME_ISSUE_DATE,
                        ).toLocaleDateString("en-IN")}
                      </td>
                    </tr>

                    {previewData?.RATION_CARD_NAME&& (
                    <>
                    <tr>
                      <th>Ration Card Name</th>
                      <td>{previewData?.RATION_CARD_NAME || "N/A"}</td>
                      <th>Ration Card Issued By</th>
                      <td>{previewData?.RATION_ISSUED_BY || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Ration Card Issued Date</th>
                      <td colSpan="3">
                        {previewData?.RATION_ISSUE_DATE
                          ? new Date(
                              previewData.RATION_ISSUE_DATE,
                            ).toLocaleDateString("en-IN")
                          : "N/A"}
                      </td>
                    </tr>
                    </>
                  )}
                  </tbody>
                </table>
              </div>
              <div className="row text-center justify-content-center mt-4">
                <tr></tr>
                <button
                  className="btn btn-warning w-50"
                  onClick={() => navigate("/personal")}
                >
                  Edit
                </button>

                <button
                  className="btn btn-success w-50"
                  onClick={() => navigate("/upload")}
                >
                  Next
                </button>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
}
